import React from 'react';
import './FloatingChecklist.css'
import { Col, Row } from 'reactstrap';
import SystemLabel from '../../system/SystemLabel/SystemLabel';

export const FloatingChecklist = ({ list, onCheck }) => {
    return <div className="floating-check-list">
        {list.map((a, i) => {
            return <div className="check-item" onClick={() => onCheck(a.address)} key={i}>{a.address}</div>
        })}
    </div>
}

export const FloatingGenericList = ({ list, onCheck }) => {
    return <div className="floating-g-list">
        {list.map((a, i) => {
            return <Row className="check-g-item" onClick={() => onCheck(a.id)} key={i}>
                <Col className="text-left">
                    {a.name}
                </Col>
                <Col className="text-right type-text">
                    <SystemLabel name={a.type} />
                </Col>
            </Row>
        })}
    </div>
}